import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import toast from 'react-hot-toast';

export function useGroupData(groupId) {
  const [group,    setGroup]    = useState(null);
  const [members,  setMembers]  = useState([]);
  const [events,   setEvents]   = useState([]);
  const [finances, setFinances] = useState([]);
  const [todos,    setTodos]    = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    if (!groupId) return;
    Promise.all([
      supabase.from('groups').select('*').eq('id', groupId).single(),
      supabase.from('member_groups')
        .select('role, members(id,first_name,last_name,phone,status,district_id,districts(name),family_id,families(name),membership_type)')
        .eq('group_id', groupId),
      supabase.from('group_events').select('*').eq('group_id', groupId).order('date'),
      supabase.from('group_finances').select('*').eq('group_id', groupId).order('date', { ascending: false }),
      supabase.from('group_todos').select('*').eq('group_id', groupId).order('created_at', { ascending: false }),
    ]).then(([g, mg, ev, fin, td]) => {
      setGroup(g.data);
      setMembers((mg.data || []).map(x => ({ ...x.members, group_role: x.role })).filter(Boolean));
      setEvents(ev.data   || []);
      setFinances(fin.data || []);
      setTodos(td.data    || []);
      setLoading(false);
    });
  }, [groupId]);

  const refreshEvents   = () => supabase.from('group_events').select('*').eq('group_id', groupId).order('date').then(({ data }) => setEvents(data || []));
  const refreshFinances = () => supabase.from('group_finances').select('*').eq('group_id', groupId).order('date',{ascending:false}).then(({ data }) => setFinances(data || []));
  const refreshTodos    = () => supabase.from('group_todos').select('*').eq('group_id', groupId).order('created_at',{ascending:false}).then(({ data }) => setTodos(data || []));

  return { group, members, events, finances, todos, loading, refreshEvents, refreshFinances, refreshTodos };
}

// ── MUTATIONS ────────────────────────────────────────────────────
export async function addGroupEvent(payload) {
  const { data, error } = await supabase.from('group_events').insert(payload).select().single();
  if (error) { toast.error(error.message); return null; }
  toast.success('Event added ✅'); return data;
}

export async function deleteGroupEvent(id) {
  const { error } = await supabase.from('group_events').delete().eq('id', id);
  if (error) { toast.error(error.message); return false; }
  toast.success('Event removed'); return true;
}

export async function addGroupFinance(payload) {
  const { data, error } = await supabase.from('group_finances').insert(payload).select().single();
  if (error) { toast.error(error.message); return null; }
  toast.success('Transaction recorded ✅'); return data;
}

export async function deleteGroupFinance(id) {
  await supabase.from('group_finances').delete().eq('id', id);
  toast.success('Entry removed');
}

export async function addGroupTodo(payload) {
  const { data, error } = await supabase.from('group_todos').insert(payload).select().single();
  if (error) { toast.error(error.message); return null; }
  toast.success('Task added ✅'); return data;
}

export async function updateGroupTodo(id, payload) {
  const { data, error } = await supabase.from('group_todos').update(payload).eq('id', id).select().single();
  if (error) { toast.error(error.message); return null; }
  return data;
}

export async function deleteGroupTodo(id) {
  await supabase.from('group_todos').delete().eq('id', id);
  toast.success('Task removed');
}
